'use strict';

import merchants from '@/assets/js/api/modules/merchants';
import functions from '@/assets/js/api/functions';

import moment from 'moment';

export default {
    namespaced: true,
    state: {
        achievementDetails: {},
        merchantsList: [],
        merchantBranchesList: [],
        merchantDetails: {},
        newMerchantDetails: {
            name: '',
            partner: '',
            mobile: '',
            address: '',
            municipality: '',
            province: '',
            location: '',
            min_points: '',
            type: '', //VIP or REGULAR
            classification: '', //PRIMARY or BRANCH
            latitude: '',
            longitude: '',
            activate_at: '',
            deactivate_setting: 'MANUAL', //*
            deactivate_at: '',
            deactivate_duration: '',
            deactivate_duration_unit: '',
            primary_merchant_id: '',
            primary_merchant_name: ''
        },
        importFileUploadID: '',
        unvalidatedMerchants: {},
        isImportSuccess: false,
        branchMerchant: {}
    },
    getters: {
        getAchievementDetails: (state) => state.achievementDetails,
        getMerchantsList: (state) => state.merchantsList,
        getMerchantBranchesList: (state) => state.merchantBranchesList,
        getMerchantDetails: (state) => state.merchantDetails,
        getNewMerchantDetails: (state) => state.newMerchantDetails,
        getImportFileUploadID: (state) => state.importFileUploadID,
        getUnvalidatedMerchants: (state) => state.unvalidatedMerchants,
        getIsImportSuccess: (state) => state.isImportSuccess
    },
    mutations: {
        SET_ACHIEVEMENT_DETAILS(state, payload) {
            state.achievementDetails = payload;
        },
        SET_MERCHANTS_LIST(state, payload) {
            state.merchantsList = payload;
        },
        SET_MERCHANT_BRANCHES_LIST(state, payload) {
            state.merchantBranchesList = payload;
        },
        SET_MERCHANT_DETAILS(state, payload) {
            state.merchantDetails = payload;
        },
        SET_NEW_MERCHANT_DETAILS(state, payload) {
            state.newMerchantDetails = { ...state.newMerchantDetails, ...payload };
        },
        SET_IMPORT_FILE_UPLOAD_ID(state, payload) {
            state.importFileUploadID = payload;
        },
        SET_UNVALIDATED_MERCHANTS(state, payload) {
            state.unvalidatedMerchants = payload;
        },
        SET_IMPORT_SUCCESS(state, payload) {
            state.isImportSuccess = payload;
        },
        RESET_FORM(state) {
            state.newMerchantDetails = {
                name: '',
                partner: '',
                mobile: '',
                address: '',
                municipality: '',
                province: '',
                location: '',
                min_points: '',
                type: '',
                classification: '',
                latitude: '',
                longitude: '',
                activate_setting: 'immediate',
                activate_at: '',
                deactivate_setting: 'MANUAL',
                deactivate_at: '',
                deactivate_duration: '',
                deactivate_duration_unit: ''
            };
        },
        CLEAR_STATE(state) {
            state.merchantsList = undefined;
            state.merchantDetails = undefined;
        }
    },
    actions: {
        setSchedule(context, payload) {
            const data = payload.data;
            let schedule = {
                activation: {
                    status: '',
                    isScheduled: false,
                    datetime: ''
                },
                deactivation: {
                    status: '',
                    isScheduled: false,
                    datetime: ''
                }
            };

            const formatDate = (value, hasTime = 0) => {
                const time = hasTime ? ' hh:mm A' : '';
                return moment(value).format(`DD MMM YYYY${time}`);
            };

            return new Promise((resolve) => {
                if (data.status == 'ACTIVE' || data.status == 'INACTIVE') {
                    if (data.deactivate_at && (data.deactivate_setting == 'BY_DATE' || data.deactivate_setting == 'BY_DURATION')) {
                        schedule.deactivation = {
                            status: 'Deactivation',
                            isScheduled: true
                        };

                        if (data.deactivate_setting == 'BY_DURATION') {
                            schedule.deactivation.datetime = formatDate(data.deactivate_at, 1);
                        } else if (data.deactivate_setting == 'BY_DATE') {
                            schedule.deactivation.datetime = formatDate(data.deactivate_at);
                        }

                        schedule.hasScheduledSetting = true;
                    }
                }
                if (data.status == 'DEACTIVATED' || data.status == 'INACTIVE') {
                    if (data.activate_at) {
                        schedule.activation = {
                            status: 'Activation',
                            isScheduled: true,
                            datetime: formatDate(data.activate_at)
                        };

                        schedule.hasScheduledSetting = true;
                    }
                }

                resolve(schedule);
            });
        },
        fetchMerchants(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: '/merchants', config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_MERCHANTS_LIST', response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_MERCHANTS_LIST', undefined);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchMerchantBranches(context, payload) {
            let { config, id } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: `/merchants/${id}/branches`, config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_MERCHANTS_LIST', response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_MERCHANTS_LIST', undefined);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchMyMerchantBranches(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: `/my/merchant/branches`, config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_MERCHANTS_LIST', response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_MERCHANTS_LIST', undefined);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        findBranchMerchant(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: `/merchants/${id}`, config })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        findMerchant(context, payload) {
            let { id, config, action } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: `/merchants/${id}`, config })
                    .then((response) => {
                        // console.log(response);
                        let data = response.data;
                        context.dispatch('setSchedule', { data: data }).then((schedule) => {
                            data.schedule = schedule;
                            data.activate_setting = data.activate_at ? 'scheduled' : 'immediate';

                            context.commit('SET_MERCHANT_DETAILS', data);
                            if (action != 'add') {
                                context.commit('SET_NEW_MERCHANT_DETAILS', data);
                            }
                            resolve(data);
                        });
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_MERCHANT_DETAILS', undefined);
                        context.commit('SET_NEW_MERCHANT_DETAILS', undefined);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        findMyAchievements(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: '/my/achievements', config })
                    .then((response) => {
                        context.commit('SET_ACHIEVEMENT_DETAILS', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        context.commit('SET_ACHIEVEMENT_DETAILS', undefined);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        findMyMerchant(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: '/my/merchant', config })
                    .then((response) => {
                        let data = response.data;
                        context.dispatch('setSchedule', { data: data }).then((schedule) => {
                            data.schedule = schedule;
                            data.activate_setting = data.activate_at ? 'scheduled' : 'immediate';

                            context.commit('SET_MERCHANT_DETAILS', data);
                            context.commit('SET_NEW_MERCHANT_DETAILS', data);
                            resolve(data);
                        });
                        resolve(response);
                    })
                    .catch((error) => {
                        context.commit('SET_MERCHANT_DETAILS', undefined);
                        context.commit('SET_NEW_MERCHANT_DETAILS', undefined);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        findMerchantQR(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: `/merchants/${id}/qr`, config })
                    .then((response) => {
                        // console.log(response);
                        let data = response.data;
                        context.dispatch('setSchedule', { data: data }).then((schedule) => {
                            data.schedule = schedule;
                            context.commit('SET_MERCHANT_DETAILS', data);
                            resolve(data);
                        });
                        resolve(response);
                    })
                    .catch((error) => {
                        context.commit('SET_MERCHANT_DETAILS', undefined);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        addMerchant(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({ to: '/merchants', data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        setMerchant(context, payload) {
            let { id, data, config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .putData({ to: `/merchants/${id}`, data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        deleteMerchant(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .deleteData({ to: '/merchants', config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        downloadMerchantQR(context, payload) {
            let { id, name, data, config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({ to: `/merchants/${id}/qr/download`, data, config })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        const fileFormat = data.partner_only == 1 ? 'jpeg' : 'zip';
                        let fileName = `${name}.${fileFormat}`;
                        let contenDisposition = '';

                        if (response.headers && response.headers['content-disposition']) {
                            contenDisposition = response.headers['content-disposition'].split('filename=')[1].split(';')[0].replace(/^"|"$/g, '');
                        }

                        link.href = url;
                        link.setAttribute('download', contenDisposition ? contenDisposition : fileName);
                        document.body.appendChild(link);
                        link.click();

                        resolve(response.data);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        downloadMerchantsQR(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({ to: '/merchants/qr/download', config })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `RewardsQR.zip`);
                        document.body.appendChild(link);
                        link.click();

                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        processDownloadAsyncMerchantsQR(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                merchants
                    .bulkPostData({ to: '/merchants/qr/download-async', data, config, hasCancel: false })
                    .then((response) => {
                        // const url = window.URL.createObjectURL(new Blob([response]));
                        // const link = document.createElement('a');
                        // link.href = url;
                        // link.setAttribute('download', `RewardsQR.zip`);
                        // document.body.appendChild(link);
                        // link.click();

                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        processDownloadAsyncMerchantBranchesQR(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                merchants
                    .bulkPostData({ to: `/merchants/${id}/qr/download-with-branches-async`, config, hasCancel: false })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        checkMerchantsQRStatus(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                merchants
                    .getMerchantData({ to: `/async-tasks/${id} `, config, hasCancel: false })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        downloadAsyncMerchantsQR(context, payload) {
            let { id, data, config } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: `/async-tasks/${id}/download-output `, config })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', data.file_name);
                        document.body.appendChild(link);
                        link.click();
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        activateMerchant(context, payload) {
            let { config, id } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({ to: `merchants/${id}/activate` }, config)
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        reject(error);
                    });
            });
        },
        deactivateMerchant(context, payload) {
            let { config, id } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({ to: `merchants/${id}/deactivate` }, config)
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        reject(error);
                    });
            });
        },
        sendEmail(context, payload) {
            let { config, id, data } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({ to: `/merchants/${id}/qr/email`, data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        reject(error);
                    });
            });
        },
        addBranch(context, payload) {
            let { data, config, id } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({ to: `/merchants/${id}/branches`, data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        // Bulk upload
        removeValidData(context, payload) {
            return new Promise((resolve) => {
                const merchants = payload.merchants;
                let newMerchantRows = [];

                if (merchants.rows && merchants.rows.length > 0) {
                    newMerchantRows = Object.values(merchants.rows).filter((merchant, i) => {
                        if (merchant.errors) {
                            Object.entries(merchant.errors).forEach((error) => {
                                const key = error[0];
                                const value = error[1];
                                if (value && Array.isArray(value)) {
                                    value.forEach((e, k) => {
                                        merchants.rows[i].errors[key][k] = e.replace(/ See ID \[(.*?)\]/, '');
                                        //merchants.rows[i].errors[key][k] = e.replace(/\[(.*?)\]/, `<a href="${payload.path}/$1" target="_blank" class="merchant-link">$1</a>`);
                                    });
                                }
                            });
                            return true;
                        }
                    });
                }

                merchants.rows = newMerchantRows;
                resolve(merchants);
            });
        },
        importPrimaryMerchants(context, payload) {
            let { config, data } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({
                        to: `/merchants/import`,
                        data,
                        config
                    })
                    .then((response) => {
                        const merchants = response.data;
                        context.dispatch('removeValidData', { merchants: merchants, path: '/merchants/view' }).then((merchants) => {
                            context.commit('SET_UNVALIDATED_MERCHANTS', merchants);
                            context.commit('SET_IMPORT_FILE_UPLOAD_ID', response.data.import_file_upload_id);

                            resolve(merchants);
                        });
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_UNVALIDATED_MERCHANTS', {});
                        context.commit('SET_IMPORT_FILE_UPLOAD_ID', '');
                        reject(error);
                    });
            });
        },
        importBranchMerchants(context, payload) {
            let { config, data, id } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({
                        to: `/merchants/${id}/branches/import`,
                        data,
                        config
                    })
                    .then((response) => {
                        const merchants = response.data;
                        context.dispatch('removeValidData', { merchants: merchants }).then((merchants) => {
                            context.commit('SET_UNVALIDATED_MERCHANTS', merchants);
                            context.commit('SET_IMPORT_FILE_UPLOAD_ID', response.data.import_file_upload_id);

                            resolve(merchants);
                        });
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_UNVALIDATED_MERCHANTS', {});
                        context.commit('SET_IMPORT_FILE_UPLOAD_ID', '');
                        reject(error);
                    });
            });
        },
        importFileById(context, payload) {
            let { config, id, data } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({ to: `/import-file-uploads/${id}/import`, data, config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_IMPORT_SUCCESS', true);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_IMPORT_SUCCESS', false);
                        reject(error);
                    });
            });
        },
        fetchImportedFiles(context, payload) {
            let { config, data } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: `/import-file-uploads`, data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        reject(error);
                    });
            });
        },
        findImportedFile(context, payload) {
            let { config, id, data } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .getData({ to: `/import-file-uploads/${id}`, data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        reject(error);
                    });
            });
        },
        validateImportedFile(context, payload) {
            let { config, id, data } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({ to: `/import-file-uploads/${id}/validate`, data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        reject(error);
                    });
            });
        },
        extractImportedFileError(context, payload) {
            let { config, name, id, data } = payload || {};
            return new Promise((resolve, reject) => {
                functions
                    .postData({ to: `/import-file-uploads/${id}/extract-errors`, data, config })
                    .then((response) => {
                        const contentType = 'text/csv';
                        const url = window.URL.createObjectURL(new Blob([response], { type: contentType }));
                        const link = document.createElement('a');
                        link.href = url;
                        const fileFormat = 'csv';
                        link.setAttribute('download', `${name}.${fileFormat}`);
                        document.body.appendChild(link);
                        link.click();
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        reject(error);
                    });
            });
        },
        processMerchantBulkUpload(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                merchants
                    .bulkPostData({ to: '/merchants', config, hasCancel: false })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_MERCHANTS_LIST', response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_MERCHANTS_LIST', undefined);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        }
    }
};
